import {AnalysisRowValue} from '@app/model';

export class AnalysisUtil {
	public static getListItemBgColor(selectedRowValue: AnalysisRowValue | undefined, expectedRowValue: AnalysisRowValue) {
		return selectedRowValue === expectedRowValue ? 'rgba(2,155,224,0.06)' : undefined
	}
}
